import { Component, OnInit } from '@angular/core';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';
import { IFilterFilters } from '../ifilter';

@Component({
    selector: '[app-dmv-state-filter]',
    templateUrl: './dmv-state-filter.component.html',
    styleUrls: ['./dmv-state-filter.component.scss'],
    host: { 'class': 'control' },
    standalone: false
})
export class DmvStateFilterComponent implements OnInit, IFilterFilters {
  // Default to "All" (no filter). Previously defaulted to "Missing" which hid most records unintentionally.
  public SelectedState: string = "all";
  public FilterName: string = "dmvstate";
  public Filters: Datalistrequestfilter[] = [];
  public QueryParamPrefix: string = '';

  ngOnInit(): void {
    this.Apply();
  }

  public StateChanged(event: any): void {
    this.SelectedState = event?.target?.value ?? "";
    this.Apply();
  }

  private Apply(): void {
    this.Filters = [];

    // Empty/all => no filter
    if (this.SelectedState === "" || this.SelectedState === "all") {
      return;
    }

    this.Filters.push({
      Property: "DMVState",
      Comparator: "==",
      Value: this.SelectedState,
      FilterName: this.FilterName
    });
  }
}

